module.exports = __webpack_public_path__ + "static/three-a73a979745b5ea2070fa6efdc4213d8f.svg";